import { z } from 'zod';
/**
 * Every error the API returns carries one of these codes. Clients switch on the code,
 * never on the message — messages are copy and will change.
 */
export const ErrorCode = {
    /** 400 — Zod rejected the request */
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    /** 401 — missing / invalid access token */
    UNAUTHORIZED: 'UNAUTHORIZED',
    /** 401 — access token expired; the client should refresh and retry once */
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    /** 402 — authenticated but no entitlement. THIS IS THE PAYWALL TRIGGER. */
    ENTITLEMENT_REQUIRED: 'ENTITLEMENT_REQUIRED',
    /** 403 */
    FORBIDDEN: 'FORBIDDEN',
    /** 404 */
    NOT_FOUND: 'NOT_FOUND',
    /** 409 */
    CONFLICT: 'CONFLICT',
    /** 409 — tried to open a day that has not been unlocked yet */
    DAY_LOCKED: 'DAY_LOCKED',
    /** 429 — always accompanied by a Retry-After header */
    RATE_LIMITED: 'RATE_LIMITED',
    /** 409 — a journey failed its publish checks; details.issues says why */
    PUBLISH_BLOCKED: 'PUBLISH_BLOCKED',
    /** 409 — the resource is not in a state that allows this operation */
    INVALID_STATE: 'INVALID_STATE',
    /** 400 — upload exceeds the hard 50 MB ceiling */
    UPLOAD_TOO_LARGE: 'UPLOAD_TOO_LARGE',
    /** 409 — finalize ran but nothing was actually uploaded to the bucket */
    OBJECT_NOT_FOUND: 'OBJECT_NOT_FOUND',
    /** 400 — the submitted code is wrong */
    OTP_INVALID: 'OTP_INVALID',
    /** 400 — the code expired; request a new one */
    OTP_EXPIRED: 'OTP_EXPIRED',
    /** 401 — the refresh token is unknown, spent or revoked */
    REFRESH_INVALID: 'REFRESH_INVALID',
    /** 409 — onboarding has already been completed; it is never shown twice */
    ALREADY_ONBOARDED: 'ALREADY_ONBOARDED',
    /** 500 */
    INTERNAL: 'INTERNAL',
};
/** The one and only error shape the API ever returns. */
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.record(z.unknown()),
    }),
});
//# sourceMappingURL=errors.js.map